// Pure decision rule behind useStableHeight — split out so the invariant it
// keeps ("height-only churn never updates the memo") is checkable without a
// render, the same reason widgetPosition's geometry is a plain function too.

export interface HeightMemo { width: number; height: number }

/**
 * Keeps `memo.height` unless `width` has actually changed; only then does it
 * adopt the live `height` as the new baseline.
 */
export function nextStableHeight(memo: HeightMemo, width: number, height: number): HeightMemo {
  if (width === memo.width) return memo;
  return { width, height };
}
